<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <form ref="formRef">
    <slot />
    <button class="submitProxy" type="submit" aria-hidden="true" tabindex="-1" style="display:none" />
  </form>
</template>

<script setup>
import {nextTick, onMounted, ref} from "vue";

const formRef = ref(null);

function focusFirstFocusable() {
  const form = formRef.value;
  if (!form) return;
  const selector = "input:not([disabled]),button:not([disabled]):not(.submitProxy)";
  const target = form.querySelector(selector);
  if (target) target.focus();
}

onMounted(() => nextTick(focusFirstFocusable));
</script>

<style scoped>
form {
  display: flex;
  flex-direction: column;
}
form > * {
  width: 100%;
  max-width: 100%;
  margin-bottom: 0.5rem;
}
:deep(h2) {
  font-size: 2.4rem;
  font-weight: 800;
  color: #1a1a1a;
  margin: 0 0 0.75rem 0;
  padding: 0;
}
:deep(h3) {
  font-size: 1rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 1.2rem 0;
  line-height: 1.4;
}
:deep(p) {
  font-size: 0.95rem;
  line-height: 1.5;
  color: #444;
  margin: 0 0 0.5rem 0;
}
:deep(small) {
  color: #888;
  font-size: 0.85rem;
  line-height: 1.4;
}
:deep(.error) {
  color: #c0392b;
  font-size: 0.9rem;
  margin: 0;
}
:deep(input) {
  padding: 0.65rem 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid #ccc;
  background: #fff;
  font-size: 1rem;
  width: 100%;
  box-sizing: border-box;
  box-shadow: none;
  margin-bottom: 1.25rem;
  margin-top: 0;
}
:deep(input:focus) {
  outline: none;
  border-color: #3ddc97;
  box-shadow: 0 0 0 3px rgba(61, 220, 151, 0.25);
}
:deep(button) {
  border: none;
  border-radius: 0.5rem;
  padding: 0.75rem;
  width: 100%;
  background: #3ddc97;
  color: #fff;
  font-weight: bold;
  font-size: 1rem;
  cursor: pointer;
  box-shadow: none;
}
:deep(button:hover:not(:disabled)) {
  opacity: 0.9;
}
:deep(button:disabled) {
  background: #aaa;
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
